import * as Phaser from "phaser";
import { ApiGlobalPlugin } from "$/game/plugins/ApiGlobalPlugin.ts";
import { OverlayScenePlugin } from "$/game/plugins/OverlayScenePlugin.ts";
import { StorageGlobalPlugin } from "$/game/plugins/StorageGlobalPlugin.ts";
import { TransitionScenePlugin } from "$/game/plugins/TransitionScenePlugin.ts";
import { CommonVarsGlobalPlugin } from "$/game/plugins/CommonVarsGlobalPlugin.ts";
import { TelegramGlobalPlugin } from "$/game/plugins/TelegramGlobalPlugin.ts";
import { SettingsGlobalPlugin } from "$/game/plugins/SettingsGlobalPlugin.ts";
import { SoundManagerGlobalPlugin } from "$/game/plugins/SoundManagerGlobalPlugin.ts";
import { KeysManagerGlobalPlugin } from "$/game/plugins/KeysManagerGlobalPlugin.ts";

export abstract class BasicScene extends Phaser.Scene {
  // global plugins
  public api!: ApiGlobalPlugin;
  public storage!: StorageGlobalPlugin;
  public global!: CommonVarsGlobalPlugin;
  public telegram!: TelegramGlobalPlugin;
  public settings!: SettingsGlobalPlugin;
  public soundManager!: SoundManagerGlobalPlugin;
  public keys!: KeysManagerGlobalPlugin;
  // scene plugins (no need to be initialized in init)
  public overlay!: OverlayScenePlugin;
  public transition!: TransitionScenePlugin;

  /** Shortcut for main atlas key */
  get atlas(): string {
    return this.keys?.atlas ?? "main";
  }

  // deno-lint-ignore constructor-super
  constructor(keyOrConfig: string | Phaser.Types.Scenes.SettingsConfig) {
    if (typeof keyOrConfig === "string") {
      super({ key: keyOrConfig });
    } else {
      super(keyOrConfig);
    }
  }

  preload() {
    // init global plugins
    this.api = this.plugins.get("api") as ApiGlobalPlugin;
    this.storage = this.plugins.get("storage") as StorageGlobalPlugin;
    this.global = this.plugins.get("globalVars") as CommonVarsGlobalPlugin;
    this.telegram = this.plugins.get("telegram") as TelegramGlobalPlugin;
    this.settings = this.plugins.get("settings") as SettingsGlobalPlugin;
    this.soundManager = this.plugins.get(
      "soundManager",
    ) as SoundManagerGlobalPlugin;
    this.keys = this.plugins.get("keysManager") as KeysManagerGlobalPlugin;
  }
}
